import * as XLSX from 'xlsx';
import { serializeCandidateReportWorkbook } from '../../candidateReportWorkbook';

export type LaiPatientReportRow = { cells: Array<{ key: string; value: string | null }> };

const columns = [
  ['id', '', 10], ['name', 'Name', 25], ['program', 'Program', 20], ['fin', 'FIN', 20],
  ['order_med', 'Order', 60], ['doctor_initials', 'Doctor Initials', 20], ['nurse_initials', 'Nurse Initials', 20],
  ['date_ordered', 'Date Ordered', 20], ['date_given', 'Date Given', 20], ['next_due', 'Next Due', 20], ['confidential_notes', 'Confidential Notes', 70],
] as const;

export const buildLaiPatientReportWorkbook = async (rows: LaiPatientReportRow[], password: string): Promise<ArrayBuffer> => {
  const sheet = XLSX.utils.aoa_to_sheet([
    ['LAI Hearings List'], [], columns.map(([, label]) => label),
    ...rows.map((row, index) => {
      const values = Object.fromEntries(row.cells.map((cell) => [cell.key, cell.value]));
      return columns.map(([key]) => key === 'id' ? index + 1 : values[key] ?? '');
    }),
  ]);
  sheet['!cols'] = columns.map(([, , wch]) => ({ wch }));
  sheet['!merges'] = [XLSX.utils.decode_range('A1:K1')];
  if (password) sheet['!protect'] = { password, sort: true, insertRows: false, formatCells: false };

  const workbook = XLSX.utils.book_new();
  workbook.Props = { Title: 'LAI Hearings List', Subject: 'Next Court Date Report', Author: 'LA County Diversion' };
  XLSX.utils.book_append_sheet(workbook, sheet, 'LAI Hearings List');
  return serializeCandidateReportWorkbook(workbook, password);
};
